import {HStack, IconButton, Input, Text} from "@chakra-ui/react";
import {AddIcon, MinusIcon} from "@chakra-ui/icons";
import * as React from "react";
import {useState} from "react";

export const PaginationInputComponent = ({page, setPage, totPage}: {
    page: number,
    setPage: (page: number) => void,
    totPage: number | undefined
}) => {
    const [pageValue, setPageValue] = useState('1');

    return <HStack ms={"48px"}>
        <Text fontWeight={'bold'}>Pagina </Text>
        <IconButton icon={<MinusIcon color={'black'}/>} aria-label={"delete"}
                    disabled={page === 1}
                    onClick={page !== 1 ? () => {
                        setPageValue((page - 1).toString());
                        setPage(page - 1)
                    } : undefined}/>
        <Input h={"48px"} w={"64px"} value={pageValue} onChange={event => setPageValue(event.target.value)}
               textAlign={'center'}
               onSubmit={event => {
                   if (Number(pageValue) < 1) {
                       setPageValue("1");
                       setPage(1);
                   } else setPage(Number(pageValue));
               }}
               onBlur={event => {
                   const value = event.target.value;
                   if (Number(pageValue) < 1) {
                       setPageValue("1");
                       setPage(1);
                   } else setPage(Number(value));
               }}/>
        <IconButton icon={<AddIcon color={'black'}/>} aria-label={"delete"}
                    onClick={page !== totPage ? () => {
                        setPageValue((page + 1).toString());
                        setPage(page + 1);
                    } : undefined}/>
        <Text> di <b>{totPage}</b></Text>
    </HStack>;
}
